import { memo } from 'react';

import { useTypedTranslation } from '~/shared/hooks';

import './footer-copy.scss';

const FooterCopy = () => {
  const currentYear = new Date().getFullYear();
  const t = useTypedTranslation(['text', 'link']);

  return (
    <div className="footer-copy">
      <meta itemProp="copyrightYear" content={String(currentYear)} />
      <meta itemProp="copyrightHolder" content={t('link.site')} />
      <span className="footer-copy__site-link">{t('link.site')}</span>
      <span className="footer-copy__year">{currentYear}</span>
      <span className="footer-copy__copy-rights">{t('text.copyrights')}</span>
    </div>
  );
};

export default memo(FooterCopy);
